const INITIAL_STATE = {
    loading: false,
    processing: false,
    negocioDoUsuario: 0,
    negocio: {},
    negocios: [],
    negocioCadastroFuncionario: {},
    uploadedLogo: [],
    segmentos: [],
    configuracoesDoNegocio: {},
    planosAtivos: [],
}

export default function Negocio(state = INITIAL_STATE, action) {
    switch(action.type) {
        case 'NEGOCIO_LOADING' :
            return { ...state, loading: action.payload };
        case 'NEGOCIO_PROCESSING' :
            return { ...state, processing: action.payload };
        case 'NEGOCIO_USUARIO_SETED' :
            return { ...state, negocioDoUsuario: action.payload};
        case 'NEGOCIO_FETCHED' :
            return { ...state, negocio: action.payload };
        case 'NEGOCIOS_FETCHED' :
            return { ...state, negocios: action.payload };
        case 'NEGOCIO_CADASTRO_FUNCIONARIO_FETCHED' :
            return { ...state, negocioCadastroFuncionario: action.payload };
        case 'UPLOADED_LOGO' :
            return { ...state, uploadedLogo: action.payload };
        case 'UPDATE_UPLOADED_LOGO':
            const data = action.payload;
            const { uploadedLogo } = state;
            const uploadingFiles = uploadedLogo.map(file => {
                return data.idTemp === file.idTemp ? { ...file, ...data } : file;
            })
            return { ...state, uploadedLogo: uploadingFiles };
        case 'DELETED_UPLOAD_LOGO':
            const id = action.payload;
            const files = state.uploadedLogo.filter(file => file.id !== id);
            return { ...state, uploadedLogo: files };
        case 'SEGMENTOS_FETCHED':
            return { ...state, segmentos: action.payload };
        case 'CONFIGURACOES_LOADING' :
            return { ...state, loading: action.payload };
        case 'CONFIGURACOES_FETCHED' :
            return { ...state, configuracoesDoNegocio: action.payload };
        case 'CONFIGURACOES_UPDATED' :
            return { ...state, configuracoesDoNegocio: action.payload };
        case 'PLANOS_ATIVOS_FETCHED' :
            return { ...state, planosAtivos: action.payload };
        default :
            return state
    }
}